import { endpoint, remoteCreate, remoteModifyPut } from "./utils.js";
import axios from 'axios';

// MaintenanceData
export function maintenanceDataRootURL() {
  return endpoint("internal/current/maintenancedatas/");
}

export async function fetchMaintenanceData(parkId) {
  try {
    const res = await axios.get(`${maintenanceDataRootURL()}${parkId}/`, {
      withCredentials: true
    });
    return res.data;
  } catch (e) {
    if (e.response) {
      if (e.response.status === 404) return null;
    }
    throw e;
  }
}

export async function createMaintenanceData(useAlerts, payload) {
  await remoteCreate(useAlerts, maintenanceDataRootURL(), payload, 'Maintenance Data', 'MaintData', 'park');
}

export async function modifyMaintenanceData(useAlerts, payload, parkId) {
  await remoteModifyPut(useAlerts, `${maintenanceDataRootURL()}${parkId}/`, payload, 'Maintenance Data', 'MaintData', 'park');
}
